import { TierLevels } from 'types/session/user'

export const LABELS_TIERS: Record<TierLevels, string> = {
	[TierLevels.TIER_1]: 'club.level.member.text',
	[TierLevels.TIER_2]: 'club.level.classic.text',
	[TierLevels.TIER_3]: 'club.level.iconic.text',
}
